import * as angular from 'angular';

"use strict";
angular.module('AuthCtrl', ['AuthService', 'UserService']);

export default 'AuthCtrl';


